export default "__VITE_ASSET__663c1111__"